import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterPsycholoogPage() {
  return <ClusterPageTemplate clusterName="Psycholoog" sectorName="Zorgpraktijken" sectorSlug="zorgpraktijken" heroTitle="Website laten maken voor een psycholoog" heroDescription="Een rustgevende, professionele website voor jouw psychologiepraktijk of GGZ-instelling. Wij bouwen websites die vertrouwen wekken en de drempel verlagen." websiteOnderdelen={[{
    icon: 'HeartPulseIcon',
    title: 'Klachten & Behandelingen',
    description: 'Invoelende beschrijvingen van klachten (zoals burn-out, angst, trauma) en jullie behandelmethoden (zoals EMDR, CGT).'
  }, {
    icon: 'UsersIcon',
    title: 'Over de behandelaar',
    description: 'Een persoonlijke introductie is in de GGZ cruciaal. Patiënten willen weten bij wie ze op de bank komen te zitten.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Aanmelden & Werkwijze',
    description: 'Heldere uitleg over de stappen: van verwijzing door de huisarts tot de intake en de behandeling.'
  }, {
    icon: 'FileTextIcon',
    title: 'Tarieven & Vergoedingen',
    description: 'Transparante informatie over contractvrij werken of gecontracteerde zorg en het eigen risico.'
  }]} functionaliteiten={[{
    icon: 'ShieldCheckIcon',
    title: 'Veilig aanmelden',
    description: 'AVG-proof formulieren via een beveiligde verbinding voor het veilig doorgeven van persoonsgegevens.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: 'Zorg dat mensen die in jouw regio zoeken naar hulpverlening, jouw praktijk bovenaan in Google vinden.'
  }, {
    icon: 'BookOpenIcon',
    title: 'Kennisbank / Blog',
    description: 'Een platform om artikelen te delen over mentale gezondheid, wat helpt bij SEO en autoriteit.'
  }]} siblingClusters={[{
    name: 'Fysiotherapie',
    slug: 'fysiotherapie'
  }, {
    name: 'Tandarts',
    slug: 'tandarts'
  }, {
    name: 'Huisarts',
    slug: 'huisarts'
  }]} faqs={[{
    q: 'Hoe zorgen we dat de website rust en vertrouwen uitstraalt?',
    a: 'We gebruiken zachte kleuren, veel witruimte, ronde vormen en authentieke (geen stock) fotografie om een veilige, laagdrempelige sfeer te creëren.'
  }, {
    q: 'Mogen we medische gegevens via de website ontvangen?',
    a: 'Standaard contactformulieren via e-mail zijn hiervoor niet veilig genoeg. We kunnen werken met beveiligde formulieren (zoals ZorgMail integraties) of patiënten via de site naar een beveiligd portaal leiden.'
  }, {
    q: 'Wat kost een website voor een psychologiepraktijk?',
    a: 'Een professionele website start vanaf €1.500. De prijs hangt af van de hoeveelheid content (klachten/behandelingen) die we moeten inrichten.'
  }, {
    q: 'Kan ik een wachttijd-indicator toevoegen?',
    a: 'Ja, we kunnen een module inbouwen waarmee je zelf heel eenvoudig de actuele wachttijden voor intake en behandeling kunt updaten, zoals vereist door de NZa.'
  }]} data-id="element-1090" />;
}